import { IUpdateContasPagarUseCase } from "../../../presentation/useCases/update/update_contas_pagar_use_case";
import { ContasPagar } from "../../models/contas_pagar";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * UpdateContasPagarUseCase
 */

export class UpdateContasPagarUseCase implements IUpdateContasPagarUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async updateContasPagar(form: ContasPagar): Promise<number> {
    return await this.repository.updateContasPagar(form);

  }
}
